export default {
  title: {
    step1Request: 'Request',
    step1Identity: 'Identity',
    step2: 'Risk',
    step3: 'Risk Result',
    step4: 'Summary',
    step5Ok: 'Completed',
    step5Ko: 'Process interrupted',
    step5StripeRetry: 'New card',
    notFound: 'Not found',
    error: 'Error',
    legal: 'Legal'
  },
  message: {
    generic: {
      loadingData: 'Loading data',
      moreInfo: 'More info',
      messageCongratulations: '"Congratulations" Your application has been approved. ',
      textReference: 'Ayvens operation reference:'
    }
  },
  language: {
    en: 'English',
    es: 'Spanish'
  },
  ui: {
    button: {
      btnBack: 'Back',
      btnSave: 'Save',
      btnCancel: 'Cancel',
      btnAccept: 'Accept',
      btnClose: 'Close',
      btnCreate: 'Create',
      btnConfirm: 'Confirm',
      btnChange: 'Change',
      btnDelete: 'Delete',
      btnRecord: 'Save',
      btnClear: 'Clear',
      btnContinue: 'Continue',
      messageSend: 'Sending...',
      btnAcceptContinue: 'Accept and continue',
      btnIsCompany: 'I am a company'
    },
    label: {
      driverLicense: 'Driver License',
      renovation: 'Renovation',
      renovationExplanation: ' (in case you have a car with Ayvens that you are going to return)',
      plateNumber: 'Plate number',
      personalData: 'Personal data',
      companyData: 'Company data',
      contactData: 'Contact data',
      about: 'About you',
      reserved: 'Reserved',
      error: 'Error'
    },
    placeholder: {
      genre: 'Genre',
      profession: 'Profession',
      birthDate: 'Borth Date',
      maritalStatus: 'Marital Status',
      email: 'Email',
      mobilePhone: 'Mobile Phone',
      streetType: 'Street Type',
      address: 'Address',
      postCode: 'Post Code',
      town: 'Town',
      name: 'Name',
      surname: 'Surname',
      surname2: 'Second surname',
      documentTypes: 'Document Type',
      documentId: 'Document Number (DNI, NIE)',
      cif: 'CIF',
      nif: '/NIF',
      fax: 'Fax',
      signType: 'Tipo de firma',
      phone: 'Phone',
      issueDate: 'Issue of date',
      operationOwner: 'Operation of',
      marketPlaceOrderId: 'Internal reference'
    }
  },
  transaction: {
    secureTransaction: 'Secure transaction'
  },
  error: {
    undefined: 'Oops! Something went wrong!',
    notFound: "This page doesn't exist.",
    amazonPayRequired:
      'After login with your Amazon account, select the payment method and then the consent box.',
    eIdRequired: 'Electronic identification is necessary.',
    noOptionsTown: 'We did not find your Location, please check your Zip Code.',
    paymentOptionsEmpty:
      'You cannot continue the process because the upload of payment methods has not been correct, please try again later.'
  },
  success: {}
};
